// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3eIZD","notes":"Notes_notes__1MKk4","note":"Notes_note__1yPfE","markdown":"Notes_markdown__1M14Y"};